import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AutocompleteScrollDirective } from './autocomplete-scroll.directive';
import { DisableAutocompleteDirective } from './disable-autocomplete.directive';
import { DisableControlDirective } from './disable-control.directive';
import { TemplateDirective } from './template.directive';

@NgModule({
  imports: [ReactiveFormsModule],
  declarations: [AutocompleteScrollDirective, DisableControlDirective, DisableAutocompleteDirective, TemplateDirective],
  exports: [AutocompleteScrollDirective, DisableControlDirective, DisableAutocompleteDirective, TemplateDirective],
})
export class CoreDirectivesModule {}
